var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchCircleLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.32227,
    y: 8.32129,
    width: 63.3571,
    height: 63.3571,
    rx: 31.6786,
    stroke: "#EEEEEE",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5723,
    y: 12.5713,
    width: 54.8571,
    height: 54.8571,
    rx: 27.4286,
    fill: "#00FFE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6673 38.6669C50.3412 36.3206 49.2527 34.1465 47.5695 32.4796C45.8863 30.8127 43.7017 29.7455 41.3522 29.4423C39.0028 29.1392 36.6188 29.6169 34.5676 30.8019C32.5164 31.9869 30.9116 33.8135 30.0007 36.0003M29.334 30.6669V36.0003H34.6673M29.334 41.3336C29.6601 43.68 30.7486 45.854 32.4318 47.5209C34.115 49.1878 36.2996 50.255 38.6491 50.5582C40.9985 50.8613 43.3825 50.3836 45.4337 49.1986C47.4849 48.0136 49.0897 46.187 50.0006 44.0002M50.6673 49.3336V44.0002H45.334M38.6673 40.0002C38.6673 40.3539 38.8078 40.693 39.0578 40.9431C39.3079 41.1931 39.647 41.3336 40.0007 41.3336C40.3543 41.3336 40.6934 41.1931 40.9435 40.9431C41.1935 40.693 41.334 40.3539 41.334 40.0002C41.334 39.6466 41.1935 39.3075 40.9435 39.0574C40.6934 38.8074 40.3543 38.6669 40.0007 38.6669C39.647 38.6669 39.3079 38.8074 39.0578 39.0574C38.8078 39.3075 38.6673 39.6466 38.6673 40.0002Z",
    stroke: "#00332D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchCircleLight);
export default __webpack_public_path__ + "static/media/switch-circle-light.61128d7caf3e688fb7e03c1af3d7f81c.svg";
export { ForwardRef as ReactComponent };